var map = {
	"./CerrarToggle.png": 519,
	"./FondoMenuMovil.AVIF": 9450,
	"./LogoUnicahICC.AVIF": 5513,
	"./Vector.AVIF": 3000,
	"./wulu.AVIF": 2317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7314;